type ArchiveFilterResponse = {
    success: boolean;
    data?: {
        html?: string;
        count?: number;
    };
};

document.querySelectorAll<HTMLFormElement>('[data-archive-filter]').forEach((form) => {
    const archive = form.closest<HTMLElement>('.opdracht-archive, .professional-archive');
    const grid = archive?.querySelector<HTMLElement>('.archive-grid');
    const count = archive?.querySelector<HTMLElement>('[data-archive-count]');
    const ajaxUrl = form.dataset.ajaxUrl;
    const action = form.dataset.action;
    const nonce = form.dataset.nonce;
    let activeRequest: AbortController | null = null;

    if (!grid || !ajaxUrl || !action || !nonce) {
        return;
    }

    const setLoading = (loading: boolean) => {
        form.classList.toggle('is-loading', loading);
        grid.classList.toggle('is-loading', loading);

        const submit = form.querySelector<HTMLButtonElement>('[type="submit"]');

        if (submit) {
            submit.disabled = loading;
        }
    };

    const updateResults = async () => {
        activeRequest?.abort();
        activeRequest = new AbortController();

        const data = new FormData(form);
        data.append('action', action);
        data.append('nonce', nonce);

        setLoading(true);

        try {
            const response = await fetch(ajaxUrl, {
                method: 'POST',
                body: data,
                signal: activeRequest.signal,
            });

            const result = await response.json() as ArchiveFilterResponse;

            if (!result.success || !result.data) {
                throw new Error('Filter request failed');
            }

            grid.innerHTML = result.data.html ?? '';

            if (count) {
                const total = result.data.count ?? 0;
                const singular = form.dataset.countSingular ?? 'item';
                const plural = form.dataset.countPlural ?? 'items';
                count.textContent = `${total} ${total === 1 ? singular : plural} gevonden`;
            }
        } catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') {
                return;
            }

            grid.innerHTML = '<p class="archive-empty">Er ging iets mis met filteren. Probeer het opnieuw.</p>';
        } finally {
            setLoading(false);
        }
    };

    form.addEventListener('submit', (event) => {
        event.preventDefault();
        updateResults().then();
    });
});

export {};
